// Chakra imports
import { Box, SimpleGrid, Spinner, Center } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import LiveService from "api/liveService";
import UserTable from "./components/UserTable";

export default function Settings() {


  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <UserTable />
      </SimpleGrid>
    </Box>
  );
}
